export default __webpack_public_path__ + "static/media/tick.19bb8fd8.png";